import { css } from '@emotion/react';
import { responsive } from '@wci-tech/core-ui';

import type { ITheme } from '@wci-tech/core-ui';

const DESKTOP_LAYOUT_WIDTH = 1920;
const DESKTOP_SIDE_GUTTER = 64;

export const getDesktopContentMaxWidth = (theme: ITheme) =>
  `calc(${theme.spacing.get(DESKTOP_LAYOUT_WIDTH)} - (${theme.spacing.get(DESKTOP_SIDE_GUTTER)} * 2))`;

export const getSharedDesktopContainer = (theme: ITheme) =>
  responsive.create({
    maxWidth: {
      default: '100%',
      md: '100%',
      lg: getDesktopContentMaxWidth(theme),
    },
  });

export const getPageContainerStyles = (
  theme: ITheme,
  options?: {
    paddingTop?: {
      default: string;
      md: string;
      lg: string;
    };
    paddingBottom?: {
      default: string;
      md: string;
      lg: string;
    };
    paddingLeft?: {
      default: string;
      md: string;
      lg: string;
    };
    paddingRight?: {
      default: string;
      md: string;
      lg: string;
    };
  },
) => css`
  width: 100%;
  margin: 0 auto;

  ${getSharedDesktopContainer(theme)};

  ${responsive.create({
    paddingTop: {
      default: options?.paddingTop?.default ?? theme.spacing.get(12),
      md: options?.paddingTop?.md ?? theme.spacing.get(12),
      lg: options?.paddingTop?.lg ?? theme.spacing.get(24),
    },
    paddingBottom: {
      default: options?.paddingBottom?.default ?? theme.spacing.get(12),
      md: options?.paddingBottom?.md ?? theme.spacing.get(12),
      lg: options?.paddingBottom?.lg ?? theme.spacing.get(24),
    },
    paddingLeft: {
      default: options?.paddingLeft?.default ?? theme.spacing.get(16),
      md: options?.paddingLeft?.md ?? theme.spacing.get(24),
      lg: options?.paddingLeft?.lg ?? theme.spacing.get(64),
    },
    paddingRight: {
      default: options?.paddingRight?.default ?? theme.spacing.get(16),
      md: options?.paddingRight?.md ?? theme.spacing.get(24),
      lg: options?.paddingRight?.lg ?? theme.spacing.get(64),
    },
  })}
`;

export const getStickyContainerWidthStyles = (theme: ITheme) => css`
  width: 100%;
  margin: 0 auto;
  ${getSharedDesktopContainer(theme)};
`;

export const getCommonChipStyles = (theme: ITheme) => ({
  chipContainer: css`
    background-color: var(--chip-bg);
    border: none;
    ${responsive.create({
      padding: {
        default: `${theme.spacing.add(4, 2)} ${theme.spacing.get(8)}`,
        md: `${theme.spacing.get(8)} ${theme.spacing.get(10)}`,
        lg: `${theme.spacing.get(10)} ${theme.spacing.get(12)}`,
      },
      marginBottom: {
        default: `${theme.spacing.get(24)}`,
        lg: `${theme.spacing.get(32)}`,
      },
    })}
  `,

  chipLabel: css`
    font-weight: 600;
    color: var(--brand-color);

    ${responsive.create({
      fontSize: {
        default: `${theme.fonts.size.xxs}`,
        md: `${theme.fonts.size.xxs}`,
        lg: `${theme.fonts.size.sm}`,
      },
    })}
  `,
});
